import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchUnconfirmedBillings } from '../api/parking-billing.ts';
import { ParkingBilling } from '../models/parkingBilling.ts';

export default function useUnconfirmedBillings(): UseQueryResult<
  ParkingBilling[],
  Error
> {
  const queryFn = fetchUnconfirmedBillings;
  return useQuery({ queryKey: ['unconfirmedBillings'], queryFn });
}
